import { Select } from 'antd';
import type {
  BaseOptionType,
  DefaultOptionType,
  RefSelectProps,
  SelectProps,
} from 'antd/es/select';
import React from 'react';
import AppTooltip from './AppTooltip';

export type AppMultiSelectProps<
  ValueType = unknown,
  OptionType extends BaseOptionType | DefaultOptionType = DefaultOptionType
> = SelectProps<ValueType, OptionType>;

function getOptionLabel(opt: { label?: React.ReactNode; value?: unknown }): string {
  const label = opt?.label;
  if (label != null && typeof label === 'string') return label;
  if (typeof label === 'number') return String(label);
  return opt?.value != null ? String(opt.value) : '';
}

const AppMultiSelect = React.forwardRef<RefSelectProps, AppMultiSelectProps>((props, ref) => {
  const { allowClear = false, mode, maxTagPlaceholder, ...rest } = props;

  const defaultMaxTagPlaceholder = (
    omittedValues: Array<{ label?: React.ReactNode; value?: unknown }>
  ) => {
    const labels = omittedValues.map(getOptionLabel).filter(Boolean);
    const tooltipTitle = labels.join(', ');
    return (
      <AppTooltip title={tooltipTitle}>
        <span>+{omittedValues.length}</span>
      </AppTooltip>
    );
  };

  return (
    <Select
      ref={ref}
      allowClear={allowClear}
      mode={mode ?? 'multiple'}
      maxTagPlaceholder={maxTagPlaceholder ?? defaultMaxTagPlaceholder}
      {...rest}
    />
  );
});

AppMultiSelect.displayName = 'AppMultiSelect';

export default AppMultiSelect;
